<template>
  <a-modal
    @cancel="close"
    :width="700"
    :footer="null"
    :visible="visible"
    title="自定义链接池">
    <div>
      <a-tag @click="doCopy(`[淘口令]`)">[淘口令]</a-tag>
      <a-tag @click="doCopy(`[长口令]`)">[长口令]</a-tag>
      <a-tag @click="doCopy(`[商品图片]`)">[商品图片]</a-tag>
      <a-tag @click="doCopy(`[数据]`)">[数据]</a-tag>
    </div>
    <a-alert message="如果您的自定义中间页包含&符号，请基础设置中必须选择短链接！[长口令] 支持IOS 14 设备" :style="{margin: '10px 0'}"></a-alert>
    <a-list bordered :data-source="domain_data">
      <a-row :gutter="20" slot="header">
        <a-col :span="8">中间页地址</a-col>
        <a-col :span="5">状态</a-col>
        <a-col :span="6">备注</a-col>
        <a-col :span="5">操作</a-col>
      </a-row>
      <a-list-item slot="renderItem" :style="{ width: '100%' }" slot-scope="item, index">
        <a-row :style="{ width: '100%' }" :gutter="20" v-if="!item.edit">
          <a-col :span="8">
            <ellipsis :length="40" tooltip>
              {{item.url}}
            </ellipsis>
            </a-col>
          <a-col :span="5">
            <span v-if="item.status === 1">
              <a-tag color="green">正常</a-tag>
            </span>
            <span v-else>
              <a-tag color="red">不可用</a-tag>
            </span>
          </a-col>
          <a-col :span="6">
            <ellipsis :length="40" tooltip>
              {{item.remark}}
            </ellipsis>
          </a-col>
          <a-col :span="5">
            <a @click="handleEdit(item)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定要删除吗?"
              ok-text="删除"
              cancel-text="取消"
              @confirm="handleDel(item)"
            >
              <a>删除</a>
            </a-popconfirm>
          </a-col>
        </a-row>
        <div v-else-if="item.edit">
          <a-input :style="{width: '50%' }" placeholder="自定义中间页链接" v-model="item.url"/>
          <a-input :style="{width: '50%' }"  placeholder="备注" v-model="item.remark"/>
        </div>
      </a-list-item>
      <a-row :gutter="20" slot="footer">
        <a-button v-show="saveVisible" type="primary" :style="{marginBottom: '10px'}" @click="handleSave" block>
          保存
        </a-button>
        <a-button type="dashed" :disabled="domain_data.length >= 20" @click="pushDomain" block>
          新增链接
        </a-button>
      </a-row>
    </a-list>
  </a-modal>
</template>
<script>
import DeviceApi from '@/api/device'
import { Ellipsis } from '@/components'
export default {
  data () {
    return {
      visible: false,
      domain_data: [],
      saveVisible: false
    }
  },
  methods: {
    show (record) {
      this.visible = true
      this.getData()
    },
    pushDomain () {
      this.domain_data.push({
        url: '',
        uid: this.domain_data.length,
        remark: '',
        edit: true
      })
      this.saveVisible = true
    },
    handleEdit (item) {
      item.edit = true
      this.saveVisible = true
    },
    handleDel (item) {
      for (let index = 0; index < this.domain_data.length; index++) {
        const e = this.domain_data[index];
        // console.log(e.uid, item.uid)
        if (e.uid === item.uid) {
          this.domain_data.splice(index, 1)
          break
        }
      }
      this.handleSave()
    },
    doCopy(text) {
      this.$copyText(text)
        .then((message) => {
          this.$message.success('复制完毕')
        })
        .catch((err) => {
          this.$message.error('复制失败')
        })
    },
    handleSave () {
      let flag = false
      this.domain_data.forEach((v, i) => {
        if (!v.url) {
          flag = true
        } else {
          v.edit = null
        }
      })
      if (flag) {
        this.$message.error('中间页地址不能为空！') 
        return false
      }
      DeviceApi.saveDomain({
        url_list: JSON.stringify(this.domain_data)
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存域名池出错')
        }
      }).finally(() => {
        this.getData()
        this.saveVisible = false
      })
      // this.saveVisible = true
    },
    close () {
      this.visible = false
    },
    getData () {
      DeviceApi.getDomainList().then(res => {
        if (res.code === 1) {
          if (res.data !== '') {
            res.data.forEach((v, i) => {
              v.uid = i
            })
            this.domain_data = res.data
          }
        } else {
          this.$message.error('获取域名池出错')
        }
      })
    }
  },
  components: {
    Ellipsis
  }
}
</script>